import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Reusable person card.
 */
const PersonCard = ({ name, role, territory, avatarColor = '#e27314', avatar, link = '/persona-dettaglio', as: Tag = 'div' }) => {
  const Wrapper = link && Tag === 'a' ? Link : Tag;
  const wrapperProps = link && Tag === 'a' ? { to: link, className: 'card person-card' } : { className: 'card person-card' };

  return (
    <Wrapper {...wrapperProps}>
      <div className="person-card__avatar">
        <div
          style={{
            width: '100%',
            height: '100%',
            background: avatar ? `url(${avatar}) center/cover no-repeat` : avatarColor,
            borderRadius: 'var(--radius-full)',
          }}
        ></div>
      </div>
      <h4 className="person-card__name">{name}</h4>
      <div className="person-card__role">{role}</div>
      {territory && <div className="person-card__territory">{territory}</div>}
    </Wrapper>
  );
};

export default PersonCard;
